import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { GetEventAnnoucements } from "../../Config/API/announcements";
import { isLoading, PROFILE } from "../../Store/Features/ProfileSlice";
// import { PROFILE } from "../../Store/Features/ProfileSlice";
import useVariables from "./useVariables";

export function useFetchEventAnnoucements(role) {
  const [fetchloading, setfetchloading] = useState(true);
  const [POSTS, setPOSTS] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const loading = useSelector(isLoading);
  const profile = useSelector(PROFILE);
  const { viewer, PID } = useVariables();
  const [fetchTime, setFetchTime] = useState(500); // Default value of 500ms

  const { id: eventId } = useParams();

  const GetAllAnnoucements = async () => {
    setfetchloading(true);
    try {
      var user = "";
      let values = {};
      if (role === "player") {
        user = PID;
        values["playerId"] = viewer.id;
      } else if (role === "organizer") {
        user = PID;
        values["organizerId"] = viewer.id;
      } else user = profile?._id;

      var flag = role;

      values["eventId"] = eventId;
      const startTime = performance.now(); // Start timing
      const res = await GetEventAnnoucements(values, page, user, flag);

      const endTime = performance.now(); // End timing
      setFetchTime(endTime - startTime); // Set fetch time
      console.log("event id", eventId);

      if (!res.ok) {
        throw new Error(res.statusText + " - " + res.url);
      }
      const data = await res.json();

      setfetchloading(false);
      if (data.type !== "success") {
        Swal.fire({
          icon: "error",
          title: data?.result
        });
      } else {
        setPOSTS(data?.result || []);
        setTotalPages(data?.metaData?.totalPages || 1);
      }
      setfetchloading(false);
    } catch (e) {
      console.log(e);
      console.log(e.name === "AbortError" ? "FetchPostsRequest canceled" : e.message);
      setfetchloading(false);
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    if (viewer?.id && !loading) {
      GetAllAnnoucements(controller);
    }
    return () => {
      controller.abort();
      setfetchloading(null);
      setPOSTS([]);
    };
  }, [viewer?.id, viewer?.flag, page]);

  return {
    fetchloading,
    POSTS,
    setPOSTS,
    setPage,
    totalPages,
    page,
    fetchTime // Return fetch time
  };
}
